<template>
  <modal v-model="isVisible" size="sm" data-dismiss="modal">
    <form @submit.prevent="onSubmit">
      <div class="c-modalCard">
        <header class="c-modalCard__header">
          <h4 class="c-modalCard__title">Adicionando Imagens</h4>
          <a role="button" class="c-modalCard__close" v-on:click="close">
            <i class="i-remove"></i>
          </a>
        </header>

        <div class="c-modalCard__body">
          <div class="l-row">
            <form-group :columns="12" label="Variações">
              <multiselect
                v-model="selectedVariations"
                :options="variations"
                selectLabel=""
                selectedLabel=""
                placeholder="Selecione"
                :custom-label="variationTitle"
                track-by="sku"
                :multiple="true"
              />
            </form-group>
          </div>

          <div class="l-row">
            <form-group label="Imagem" :columns="12">
              <upload-image v-on:file="uploadedImage" :module="{ type: 'erp', identifier: 'tiny' }"/>
            </form-group>
          </div>
        </div>

        <footer class="c-modalCard__footer">
          <button type="button" class="btn btn--default" @click="close">Fechar</button>
          <button type="submit" class="btn btn--primary">Adicionar</button>
        </footer>
      </div>
    </form>
  </modal>
</template>

<script>
  import notifier from '@/notifier'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import UploadImage from '@/components/template/UploadImage'

  export default {
    data: () => ({
      selectedVariations: [],
      imagesUrl: '',
      isVisible: false
    }),
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      variations: {
        type: Array,
        required: true
      },
      callback: {
        type: Function,
        required: false
      }
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
        this.$emit('close', this.isVisible)
      },
      onSubmit () {
        if (this.selectedVariations.length <= 0) {
          notifier.error('Selecione ao menos uma variação.', 'Erro')
          return
        }

        this.callback(this.imagesUrl, this.selectedVariations)

        this.close()
      },
      uploadedImage (urls) {
        this.imagesUrl = urls
      },
      variationTitle (variation) {
        const title = [`SKU: ${variation.sku}`]

        if (variation.ean !== null && variation.ean !== undefined && variation.ean !== '') {
          title.push(`EAN: ${variation.ean}`)
        }

        for (let i in Object.keys(variation.attributes)) {
          const name = Object.keys(variation.attributes)[i]
          const value = variation.attributes[name]

          if (value === null || value === undefined) {
            continue
          }

          title.push(`${this.$t(`${name}.label`)}: ${value}`)
        }

        return title.join(' | ')
      }
    },
    watch: {
      visible () {
        this.isVisible = this.visible
      }
    },
    components: {
      FormGroup,
      Multiselect,
      UploadImage
    }
  }
</script>

<style lang="sass" scoped>
  .c-modalCard__body
    overflow: visible

</style>



// WEBPACK FOOTER //
// ModalAddImage.vue?52d53319